import { render, staticRenderFns } from "./index.vue?vue&type=template&id=d0701568&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "@/assets/scss/common/amount-popup/_amount-popup.scss?vue&type=style&index=0&id=d0701568&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0701568",
  null
  
)

export default component.exports